import { Ref, computed, ref } from "@vue/composition-api";

export const UseLoading = (startVal = false) => {
  const isLoading = ref(startVal);
  const setLoading = (loading: boolean) => (isLoading.value = loading);
  const as_arr = (): [Ref<boolean>, (loading: boolean) => void] => [
    isLoading,
    setLoading,
  ];
  return {
    isLoading,
    setLoading,
    as_arr,
  };
};

export const UseLoadingAction = <T>(
  startVal = false,
  initial_action: Partial<T>
): [
  Ref<{
    is_loading: boolean;
    action: Partial<T>;
  }>,
  (loading: boolean, action: Partial<T>) => void,
  (...keys: Partial<T>[]) => Readonly<Ref<Readonly<boolean>>>
] => {
  const loading_status: Ref<{ is_loading: boolean; action: Partial<T> }> = ref({
    is_loading: startVal,
    action: initial_action,
  });

  const setLoading = (loading: boolean, action: Partial<T>) => {
    loading_status.value.is_loading = loading;
    loading_status.value.action = action;
  };

  const is = (...keys: Partial<T>[]) => {
    return computed(
      () =>
        loading_status.value.is_loading &&
        keys.includes(loading_status.value.action)
    );
  };

  return [loading_status, setLoading, is];
};

export const UseStatefulFn = <T, E, R>(
  fn: (t: T) => Promise<E | R>
): [(input: T) => Promise<E | R>, Ref<boolean>, Ref<boolean>] => {
  const is_initial_load = ref(true);
  const [is_loading, set_loading] = UseLoading(false).as_arr();
  const run_fn = async (input: T): Promise<E | R> => {
    set_loading(true);
    const res = await fn(input);
    set_loading(false);
    is_initial_load.value = false;
    return res;
  };
  return [run_fn, is_loading, is_initial_load];
};
